// Utility function to format date in MM/DD/YYYY format
const formatDate = (date) => {
        const { day, month, year } = date;
        const updatedDate = new Date(year, month, day);

            const formattedDay = updatedDate.getDate().toString().padStart(2, '0');
            const formattedMonth = (updatedDate.getMonth() + 1).toString().padStart(2, '0');
            const formattedYear = updatedDate.getFullYear();

            return `${formattedMonth}/${formattedDay}/${formattedYear}`;
};

export default {
    'formatDate': (aDate) => formatDate(aDate),
};
